<template>
    <div class="content">
        <div class="pay-result">
            <img src="./successOrFail_img/success.png" alt="" />
            <p>{{$t('PaySuccess')}}</p>
            <a class="btn" href="http://happytalk.tw/mycard/pay/#/">{{$t('CR')}}</a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'success',
}
</script>

<style lang="stylus" scoped>
.content
    position:relative
    width:100%
    height:100vh
    display:flex
    text-align:center
    justify-content:center
    align-content:center
    .pay-result
        position:absolute
        top:30%
    .btn
        display: inline-block
        margin-top 1.25rem
        border-radius .3125rem
        padding:.375rem 1.5rem
        background :#57c22d
        color :#fff
</style>
